import { Autocomplete, CircularProgress, TextField } from "@mui/material"
import { useEffect, useMemo, useRef, useState } from "react";
import { Environment } from "../../environment";
import { SetorService, ISetor } from "../../services/api/setor/SetorService";
import { AlertSnackBar } from "../alert/AlertSnackBar";
import { AutoCompleteDeUnidade } from "./AutoCompleteDeUnidade";

type AutoCompleteOption = {
  id: number; // apenas algo que diferencie as opções, o valor q vai ser retornado ao escolher
  label: string;
}

interface IAutoComplete {
  /**
   * Deixa o autocomplete desabilitado
   */
  disabled?: boolean,
  /**
   * Fazer com que tenha a indicação que está carregando 
   */
  isExternalLoading?: boolean,
  /**
   * Altera o size do campo (para cadastro o tamanho é médio)
   */
  paraCadastro?: boolean,
  /**
   * Width do campo(padrão 200), null para não ter width e variar de acordo com a tela
   */
  width?: number | null,
  /**
   * Pegar o valor que vai retornar ao trocar opção
   */
  selectedIdSetor?: (idSetor: number | undefined) => void,
}

/**
 * selectedIdSetor={selectedIdSetor => setIdSetor(selectedIdSetor)} \
 * para pegar o valor selecionado e colocar em uma variável/state
 */

export const AutoCompleteDeSetor: React.FC<IAutoComplete> = ({ disabled = false, isExternalLoading = false, paraCadastro = false, width = 200, selectedIdSetor }) => {
  useEffect(() => {
    selectedIdSetor?.(Number(localStorage.getItem('idSetor')));
  }, [])
  const [selectedId, setSelectedId] = useState<number | null | undefined>(Number(localStorage.getItem('idSetor')));

  const [opcoes, setOpcoes] = useState<AutoCompleteOption[]>([]);

  const [idUnidade, setIdUnidade] = useState<number | undefined | null>(undefined);
  const [isLoading, setIsLoading] = useState(isExternalLoading);

  const [alertSnackbar, setAlertSnackbar] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
  const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

  useEffect(() => {// carregar os dados dos setores

    if (idUnidade === undefined || idUnidade === null || idUnidade == 0) {
      setOpcoes([]);
      selectedIdSetor?.(0);
    } else {
      setIsLoading(true);
      SetorService.list(idUnidade).then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setOpcoes([]);
          setSelectedId(undefined);

          setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
          setTimeout(() => {
            setAlertSnackbar(undefined);
          }, duracaoAlert);
        } else {
          setOpcoes(result.map(setor => ({ id: setor.idSetor, label: setor.nomeSetor })));
        }
      });
    }
  }, [idUnidade]);

  useEffect(() => {
    if (localStorage.getItem("idSetor") === null) {
      setSelectedId(undefined);
    }
  }, [localStorage.getItem("idSetor")]);

  useEffect(() => {
    if (localStorage.getItem("idUnidade")) {
      setIdUnidade(Number(localStorage.getItem("idUnidade")))
    }
  }, [])


  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.id === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);

  return (
    <>
      {paraCadastro ? (
        <AutoCompleteDeUnidade paraCadastro selectedIdUnidade={selectedIdUnidade => setIdUnidade(selectedIdUnidade)} />
      ) : (
        <AutoCompleteDeUnidade selectedIdUnidade={selectedIdUnidade => setIdUnidade(selectedIdUnidade)} />
      )}

      {alertSnackbar !== undefined && (
        <>
          {alertSnackbar.tipoAlert === "sucesso" && (
            <AlertSnackBar gravidade="success" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alertSnackbar.tipoAlert === "erro" && (
            <AlertSnackBar gravidade="error" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alertSnackbar.tipoAlert === "aviso" && (
            <AlertSnackBar gravidade="warning" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
        </>
      )}

      {idUnidade !== undefined && idUnidade !== null && idUnidade !== 0 && (
        <Autocomplete
          //traduzir textos
          openText="Abrir"
          closeText="Fechar"
          noOptionsText="Sem opções"
          loadingText="Carregando..."

          disablePortal

          //estilização
          sx={{ width: width }}
          loading={isLoading}
          popupIcon={isLoading ? <CircularProgress size={20} /> : undefined}//trocar o icone enquanto carrega os dados

          //dados
          options={opcoes}
          onChange={(_, newValue) => {
            selectedIdSetor?.(newValue?.id);
            setSelectedId?.(newValue?.id);
            if (newValue?.id) {
              localStorage.setItem('idSetor', `${newValue.id}`);
            } else {
              localStorage.removeItem('idSetor');
            }
          }}
          value={autoCompleteSelectedOption}
          renderInput={(params) => <TextField {...params} label="Setor" placeholder="Digite o nome..." size={paraCadastro ? 'medium' : 'small'} />}
        />
      )}
    </>
  );
}